import { render, staticRenderFns } from "./product_hair2.vue?vue&type=template&id=ea6abbd6&scoped=true&"
import script from "./product_hair2.vue?vue&type=script&lang=js&"
export * from "./product_hair2.vue?vue&type=script&lang=js&"
import style0 from "./product_hair2.vue?vue&type=style&index=0&id=ea6abbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6abbd6",
  null
  
)

export default component.exports